import React, { useState, useEffect, useContext } from 'react';
import Styled from 'styled';
import { NavLink, useHistory } from 'react-router-dom';

import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';

import rightArrow from 'four-nets/icons/svg/icon_arrow-right.svg';
import leftArrow from 'four-nets/icons/svg/icon_arrow-left.svg';

import defaultStyles from './sub-navigation.scss';

import { AlertContext } from 'lib/alert-context/alert-context';
import { FormattedMessage } from 'react-intl';
import { SectionCountsContext, SiteSection } from 'lib/section-count-context/section-count-context';

interface Link {
    label: string | React.ReactNode;
    to: string;
    isActive?: () => boolean;
}

interface Props {
    styles: typeof defaultStyles;
    links: Link[];
    dirty?: boolean;
    forum?: boolean;
}

const SubNavigation: React.FC<Props> = props => {
    const history = useHistory();
    const { confirm } = useContext(AlertContext);
    const { updateSectionCount } = useContext(SectionCountsContext);

    const { styles, links, dirty, forum } = props;

    const navRef = React.createRef<HTMLElement>();
    const [showRightArrow, setShowRightArrow] = useState(false);
    const [showLeftArrow, setShowLeftArrow] = useState(false);

    const updateArrows = () => {
        if (navRef && navRef.current) {
            const arrowBuffer = 50;
            const maxScroll = navRef.current.scrollWidth - navRef.current.offsetWidth;
            const newState = { showRightArrow: false, showLeftArrow: false };
            if (maxScroll && maxScroll - navRef.current.scrollLeft > arrowBuffer) {
                newState.showRightArrow = true;
            }
            if (maxScroll && navRef.current.scrollLeft > arrowBuffer) {
                newState.showLeftArrow = true;
            }

            setShowRightArrow(newState.showRightArrow);
            setShowLeftArrow(newState.showLeftArrow);
        }
    };

    useEffect(updateArrows, []);

    return (
        <nav className={styles.subNavigation} ref={navRef} onScroll={updateArrows}>
            <React.Fragment>
                {showRightArrow ? (
                    <div className={styles.rightArrowDiv}>
                        <SVGIcon src={rightArrow} className={styles.rightArrow} />
                    </div>
                ) : null}
                {showLeftArrow ? (
                    <div className={styles.leftArrowDiv}>
                        <SVGIcon src={leftArrow} className={styles.leftArrow} />
                    </div>
                ) : null}
                <ul className={styles.links}>
                    {links.map((link, index) => {
                        return (
                            <li key={link.to} className={styles.link}>
                                <NavLink
                                    to={link.to}
                                    className={styles.subNavigationLink}
                                    activeClassName={styles.active}
                                    isActive={link.isActive}
                                    exact={true}
                                    onClick={e => {
                                        if (forum) {
                                            updateSectionCount(SiteSection.FORUM);
                                        }
                                        if (dirty) {
                                            e.preventDefault();
                                            e.stopPropagation();

                                            confirm!({
                                                body: (
                                                    <>
                                                        <FormattedMessage id='LEAVE_WITHOUT_SAVING' />?
                                                    </>
                                                ),
                                                onAccept: () => history.push(link.to),
                                                title: <FormattedMessage id='LEAVE' />,
                                            });
                                        }
                                    }}
                                >
                                    {link.label}
                                </NavLink>
                            </li>
                        );
                    })}
                </ul>
            </React.Fragment>
        </nav>
    );
};

export default Styled(defaultStyles)(SubNavigation);
